import react from 'react';

export default function Header (){



    return (
        <div id='header'>
            <h1>Christopher Dirksen's Portfolio</h1>
            <p>A Front/Back-End Web Develpoer</p>
        </div>
    )
}